"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsInViewport = void 0;
const react_1 = require("react");
const getRefPosition = (entry) => {
    if (entry.isIntersecting) {
        return 'shown';
    }
    if (entry.boundingClientRect) {
        const { top, bottom, height } = entry.boundingClientRect;
        if (bottom - height <= 0) {
            return 'above';
        }
        else if (top + height >= window.innerHeight) {
            return 'below';
        }
    }
    return 'shown';
};
const useIsInViewport = (ref, options) => {
    const [isInViewport, setIsInViewport] = (0, react_1.useState)(false);
    const [refPosition, setRefPosition] = (0, react_1.useState)();
    const observer = (0, react_1.useMemo)(() => {
        if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') {
            return null;
        }
        return new IntersectionObserver(([entry]) => {
            if (!entry) {
                return;
            }
            setIsInViewport(entry.isIntersecting);
            setRefPosition(getRefPosition(entry));
        }, options);
    }, [options]);
    (0, react_1.useEffect)(() => {
        if (!observer || !(ref === null || ref === void 0 ? void 0 : ref.current)) {
            return;
        }
        observer.observe(ref.current);
        return () => {
            observer.disconnect();
        };
    }, [ref, observer]);
    return { isInViewport, refPosition };
};
exports.useIsInViewport = useIsInViewport;
